import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { messagingShape } from '@bibliocommons/bc-prop-types';
import MessagingActions from 'app/actions/MessagingActions';
import { getMessaging } from 'app/selectors/MessagingSelector';

function MessagingContainer({ messaging, id, dispatch, children }) {
  if (messaging && messaging.get('message')) {
    return children(
      {
        message: messaging.get('message'),
        fieldErrors: messaging.get('fieldErrors'),
        duration: messaging.get('duration'),
        failureDuration: messaging.get('failureDuration'),
        values: messaging.get('values'),
        clearMessages: () => dispatch(MessagingActions.clearMessages(id))
      },
      dispatch
    );
  }

  return null;
}

MessagingContainer.propTypes = {
  id: PropTypes.string.isRequired,
  messaging: messagingShape,
  dispatch: PropTypes.func.isRequired
};

const mapStateToProps = (state, ownProps) => {
  const { id } = ownProps;
  const messaging = getMessaging(state).get(id);
  return { id, messaging };
};

export default connect(mapStateToProps)(MessagingContainer);
